import {connect} from '@store/@common';

import {selectedKpiTargets} from '@store/kpi';

import KpiGoalForm from '$pages/$kpis/@common/kpi-goal-form';

const mapStateToProps = {
  selectedKpiTargets,
};

export default connect(KpiGoalForm, mapStateToProps);
